// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
    background-color: #f1f1f1;
    padding: 21px 82px;
    color: #717171;
}

.admin-main-content {
    display: flex;
    padding: 20px 40px;
}

.admin-sidebar {
    width: 220px;
    margin-right: 30px;
    flex-shrink: 0;
}

.sidebar-menu {
    margin-bottom: 34px;
}

.sidebar-menu h3 {
    font-size: 18px;
    margin: 0 0 15px 0;
}

.sidebar-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.sidebar-menu ul li {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    color: #717171;
}

.sidebar-menu ul li.active {
    color: black;
    font-weight: bold;
}

.admin-content {
    flex-grow: 1;
}

.admin-content .page-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.admin-content .page-title-bar {
    width: 5px;
    height: 24px;
    background-color: #e84118;
}

.admin-content h2 {
    font-size: 24px;
    margin: 0;
}

.search-filters {
    border: 1px solid #ddd;
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 5px;
}

.filter-group {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.filter-group:last-child {
    margin-bottom: 0;
}

.filter-group label {
    width: 100px;
    font-weight: bold;
}

.search-field select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 200px;
}

.level-options {
    display: flex;
    align-items: center;
    gap: 20px;
}

.level-options label {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: normal;
    width: auto;
}

.search-button {
    display: block;
    width: 343px;
    padding: 15px;
    background-color: #222;
    color: white;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 30px auto;
}

.stats-list-container {
    margin-top: 30px;
}

.stats-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.stats-list-header span {
    font-size: 16px;
    font-weight: bold;
}

.excel-button {
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
}

.stats-table {
    width: 100%;
    border-collapse: collapse;
}

.stats-table th, .stats-table td {
    text-align: center;
    padding: 15px 10px;
    border-bottom: 1px solid #ddd;
}

.stats-table th {
    font-weight: bold;
    border-top: 2px solid #222;
    background-color: #fff;
}

.stats-table td:nth-child(2) {
    width: 35%;
}

.progress-bar-container {
    width: 100%;
    background-color: #f0f0f0;
    border-radius: 5px;
    overflow: hidden;
    height: 20px;
}

.progress-bar {
    height: 100%;
    background-color: #e84118;
    border-radius: 5px 0 0 5px;
}

.stats-table tr:hover {
    background-color: #f5f5f5;
} `, "",{"version":3,"sources":["webpack://./src/admin/css/MonthlyStatsPage.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".breadcrumb {\n    background-color: #f1f1f1;\n    padding: 21px 82px;\n    color: #717171;\n}\n\n.admin-main-content {\n    display: flex;\n    padding: 20px 40px;\n}\n\n.admin-sidebar {\n    width: 220px;\n    margin-right: 30px;\n    flex-shrink: 0;\n}\n\n.sidebar-menu {\n    margin-bottom: 34px;\n}\n\n.sidebar-menu h3 {\n    font-size: 18px;\n    margin: 0 0 15px 0;\n}\n\n.sidebar-menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.sidebar-menu ul li {\n    padding: 10px 20px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #717171;\n}\n\n.sidebar-menu ul li.active {\n    color: black;\n    font-weight: bold;\n}\n\n.admin-content {\n    flex-grow: 1;\n}\n\n.admin-content .page-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.admin-content .page-title-bar {\n    width: 5px;\n    height: 24px;\n    background-color: #e84118;\n}\n\n.admin-content h2 {\n    font-size: 24px;\n    margin: 0;\n}\n\n.search-filters {\n    border: 1px solid #ddd;\n    padding: 20px;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n}\n\n.filter-group {\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.filter-group:last-child {\n    margin-bottom: 0;\n}\n\n.filter-group label {\n    width: 100px;\n    font-weight: bold;\n}\n\n.search-field select {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 200px;\n}\n\n.level-options {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.level-options label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-weight: normal;\n    width: auto;\n}\n\n.search-button {\n    display: block;\n    width: 343px;\n    padding: 15px;\n    background-color: #222;\n    color: white;\n    font-size: 18px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin: 30px auto;\n}\n\n.stats-list-container {\n    margin-top: 30px;\n}\n\n.stats-list-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.stats-list-header span {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.excel-button {\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.stats-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.stats-table th, .stats-table td {\n    text-align: center;\n    padding: 15px 10px;\n    border-bottom: 1px solid #ddd;\n}\n\n.stats-table th {\n    font-weight: bold;\n    border-top: 2px solid #222;\n    background-color: #fff;\n}\n\n.stats-table td:nth-child(2) {\n    width: 35%;\n}\n\n.progress-bar-container {\n    width: 100%;\n    background-color: #f0f0f0;\n    border-radius: 5px;\n    overflow: hidden;\n    height: 20px;\n}\n\n.progress-bar {\n    height: 100%;\n    background-color: #e84118;\n    border-radius: 5px 0 0 5px;\n}\n\n.stats-table tr:hover {\n    background-color: #f5f5f5;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
